import React, { useState } from 'react'
import SidebarPortfoliosRecent from 'components/Sidebars/SidebarPortfoliosRecent'
import Layout from 'components/Layout'
import Portfolios from './components/Portfolios/Portfolios'
import useMediaQuery from 'hooks/useMediaQuery'
import * as _ from 'styles/helpers'

const Portfolios_Index = () => {
	const isMobile = useMediaQuery(_.MQ.before_nav)
	const [cardDisplay, setCardDisplay] = useState(true)
	const [openPopup, setOpenPopup] = useState(false)

	// Force card display on mobile
	const effectiveCardDisplay = isMobile ? true : cardDisplay

	return (
		<Layout>
			<Layout.Page>
				<Layout.Sidebar>
					<SidebarPortfoliosRecent />
				</Layout.Sidebar>
				<Layout.Body>
					<Layout.PageHeader>
						<h2>Portfolios</h2>
					</Layout.PageHeader>
					<Portfolios
						cardDisplay={effectiveCardDisplay}
						onToggleCardDisplay={() => setCardDisplay(!cardDisplay)}
						isMobile={isMobile}
						openPopup={openPopup}
						setOpenPopup={setOpenPopup}
					/>
				</Layout.Body>
			</Layout.Page>
		</Layout>
	)
}

export default Portfolios_Index
